<template>
  <div class="booth-draft-option" v-if="exhibitionArticle">
    <img v-if="exhibitionArticle.images !== null && exhibitionArticle.images.length > 0"
      :src="'/images/articles/' + exhibitionArticle.images[0].path"
      alt="">
    <img v-else class="object-fit--contain" :src="'/images/image-placeholder.svg'" alt="">
    <div class="booth-draft-option__body">
      <div>
        <b>{{ !inEnglish ? article.name : article.name_en }}</b>
        <span v-if="exhibitionArticle.type === ARTICLE_TYPE_PRINT">
          ({{ $t('configurator.form.labels.hint_print') }})
        </span>
        <span v-if="exhibitionArticle.type === ARTICLE_TYPE_LETTERING">
          ({{ $t('configurator.form.labels.hint_lettering') }})
        </span>
      </div>
      <div class="booth-draft-option__description">
        {{ !inEnglish ? article.description : article.description_en }}
      </div>
      <div>
        {{ $filters.formatMoney(prices.price_net) }}
        <small>
          <span v-if="exhibitionArticle.unit === UNIT_SQM">/m<sup>2</sup></span>
          <span v-if="exhibitionArticle.unit === UNIT_PC">{{ $t("booth_articles.per_unit") }}</span>
        </small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { ARTICLE_TYPE_LETTERING, ARTICLE_TYPE_PRINT, UNIT_PC, UNIT_SQM } from '@/constants'

const store = useMainStore()
// define props
const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  isConfigurator: {
    type: Boolean,
    default: false
  }
})
// define computed props
const basket = computed(() => store.settings.basket)
const boothArticles = computed(() => store.tmp.booth_articles)
const inEnglish = computed(() => store.inEnglish)

const exhibitionArticle = computed(() => {
  if (props.isConfigurator) {
    const index = basket.value.selectedArticles.findIndex((item) => {
      return item.id === props.article.id
    })

    if (index > -1) {
      return basket.value.selectedArticles[index]
    }
  } else {
    const index = boothArticles.value.findIndex((item) => {
      return item.id === props.article.id
    })

    if (index > -1) {
      return boothArticles.value[index]
    }
  }
  
  return null

  
})

const prices = computed(() => {
  if (exhibitionArticle.value === null) {
    return {}
  }

  return JSON.parse(exhibitionArticle.value.pivot.prices)
})
</script>